import React, { useRef } from 'react';
// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Container, Grid, Typography, Paper, Stack, Divider } from '@mui/material';

// project imports
import AppBar from 'ui-component/extended/AppBar';
import MainCard from 'ui-component/cards/MainCard';
import Accordion from 'ui-component/extended/Accordion';
import { gridSpacing } from 'store/constant';
import faqsData from '../../../dummy_data/faqs.json';
// assets
import mailImg from 'assets/images/landing/widget-mail.svg';
import headerBackground from 'assets/images/landing/bg-header.jpg';

const HeaderWrapper = styled('div')(({ theme }) => ({
    backgroundImage: `url(${headerBackground})`,
    backgroundSize: '100% 600px',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    textAlign: 'center',
    paddingTop: 30,
    [theme.breakpoints.down('md')]: {
        paddingTop: 0
    }
}));

// External styled
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}));

// ============================|| SAAS PAGES - FAQs ||============================ //

const Faqs = () => {
    const theme = useTheme();
    const StartCaption = useRef(null);
    const FieldCaption = useRef(null);
    const HowCaption = useRef(null);

    // vì có thêm header nên khi scroll phải trừ đi 80px
    const scrollIntoViewWithMargin = (ref) => {
        const element =
            ref === 'StartCaption' ? StartCaption?.current : ref === 'FieldCaption' ? FieldCaption?.current : HowCaption?.current;
        if (element) {
            const topPosition = element?.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
                top: topPosition - 80, // Trừ đi 80px
                behavior: 'smooth'
            });
        }
    };

    return (
        <HeaderWrapper>
            <AppBar />
            <Container>
                <Grid container justifyContent="center">
                    <Grid item sm={10} md={7} sx={{ mt: { md: 12.5, xs: 2.5 }, mb: { md: 12.5, xs: 2.5 } }}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Typography
                                    variant="h1"
                                    color="white"
                                    component="div"
                                    sx={{
                                        fontSize: '3.5rem',
                                        fontWeight: 900,
                                        lineHeight: 1.4,
                                        [theme.breakpoints.down('md')]: { fontSize: '1.8125rem', marginTop: '80px' }
                                    }}
                                >
                                    Những câu hỏi thường gặp
                                </Typography>
                            </Grid>
                            <Grid item xs={12} justifyContent="center">
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    divider={<Divider orientation="vertical" flexItem />}
                                    spacing={2}
                                >
                                    <Item
                                        sx={{ cursor: 'pointer', ':hover': { opacity: '0.8' } }}
                                        onClick={() => {
                                            scrollIntoViewWithMargin('StartCaption');
                                        }}
                                    >
                                        Bắt đầu
                                    </Item>
                                    <Item
                                        sx={{ cursor: 'pointer', ':hover': { opacity: '0.8' } }}
                                        onClick={() => {
                                            scrollIntoViewWithMargin('FieldCaption');
                                        }}
                                    >
                                        Lĩnh vực
                                    </Item>
                                    <Item
                                        sx={{ cursor: 'pointer', ':hover': { opacity: '0.8' } }}
                                        onClick={() => {
                                            scrollIntoViewWithMargin('HowCaption');
                                        }}
                                    >
                                        Làm thế nào để hoạt động ?
                                    </Item>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ position: 'relative', display: { xs: 'none', lg: 'block' } }}>
                        <img
                            src={mailImg}
                            alt="Berry"
                            style={{
                                marginBottom: -0.625,
                                position: 'absolute',
                                bottom: -90,
                                right: -100,
                                width: 400,
                                maxWidth: '100%',
                                animation: '5s wings ease-in-out infinite'
                            }}
                        />
                    </Grid>
                    <Grid ref={StartCaption} item xs={12}>
                        <MainCard sx={{ textAlign: 'left', marginBottom: 2 }} elevation={4} border={false} boxShadow shadow={4}>
                            <Typography variant="h2" sx={{ color: theme.palette.main.items, textAlign: 'center' }}>
                                Bắt đầu
                            </Typography>
                            <Accordion data={faqsData.filter((data) => data.topic.trim() === 'Bắt đầu')} />
                        </MainCard>
                    </Grid>
                    <Grid ref={FieldCaption} item xs={12}>
                        <MainCard sx={{ textAlign: 'left', marginBottom: 2 }} elevation={4} border={false} boxShadow shadow={4}>
                            <Typography variant="h2" sx={{ color: theme.palette.main.items, textAlign: 'center' }}>
                                Lĩnh vực
                            </Typography>
                            <Accordion data={faqsData.filter((data) => data.topic.trim() === 'Lĩnh vực')} />
                        </MainCard>
                    </Grid>
                    <Grid ref={HowCaption} item xs={12}>
                        <MainCard sx={{ textAlign: 'left', marginBottom: 2 }} elevation={4} border={false} boxShadow shadow={4}>
                            <Typography variant="h2" sx={{ color: theme.palette.main.items, textAlign: 'center' }}>
                                Làm thế nào để hoạt động ?
                            </Typography>
                            <Accordion data={faqsData.filter((data) => data.topic.trim() === 'Làm thế nào để nó hoạt động')} />
                        </MainCard>
                    </Grid>
                </Grid>
            </Container>
        </HeaderWrapper>
    );
};

export default Faqs;
